const nodeList = []
const ctx = '@@focusOutContext'

let event
let activeComponentIndex

window.addEventListener('focus', (e) => {
  nodeList.forEach(node => node[`${ctx}`].focusHandler(e, event))
}, true)

// eslint-disable-next-line no-undef
const elementExists = (focusEvent, node) => (focusEvent.target instanceof HTMLElement) && node.context && focusEvent.target

const focusTargetExists = (elem, focusEvent) => elem.contains(focusEvent.target) || elem === focusEvent.target

const openTargetComponent = (elem, node, nodeId) => {
  if (node.context[elem[`${ctx}`].forceOpenFn]) {
    activeComponentIndex = nodeId
    node.context[elem[`${ctx}`].forceOpenFn]()
  }
}

const createUniqueId = () => Math.random().toString(36).substr(2, 9)

export default {
  bind (el, binding, vnode) {
    nodeList.push(el)
    const id = createUniqueId()

    if (!el.getAttribute('tabindex') || el.getAttribute('tabindex') === null) {
      el.setAttribute('tabindex', -1)
    }

    const focusHandler = function (focus = {}) {
      if (binding.arg === 'promoCode') {
        setTimeout(() => {}, 500)
      }
      if (!elementExists(focus, vnode)) return

      // direct focus on component
      if (focusTargetExists(el, focus) && binding.expression) {
        openTargetComponent(el, vnode, id)
        return
      }

      // focus on component's popper elem
      if (binding.arg && binding.arg.length > 0) {
        const node = nodeList.find(elem => elem[`${ctx}`].refName === binding.arg)

        if (node && focusTargetExists(node, focus)) {
          return
        }

        if (binding.arg === 'mmbForm' && focus.target.classList.contains('manage-my-booking')) {
          return
        }

        if (binding.arg === 'ckiForm' && focus.target.classList.contains('check-in-online')) {
          return
        }

        if (binding.arg === 'promoCode' && focus.target.classList.contains('e-horizon-search-form-container')) {
          return
        }
      }

      if (binding.expression && el[`${ctx}`].methodName && vnode.context[el[`${ctx}`].methodName] && activeComponentIndex !== id) {
        vnode.context[el[`${ctx}`].methodName]()
      } else if (el[`${ctx}`].bindingFn) {
        el[`${ctx}`].bindingFn()
      }
    }

    let forceOpenMethod = null
    if (vnode.data.attrs && vnode.data.attrs.focusOutForceOpen) {
      forceOpenMethod = vnode.data.attrs.focusOutForceOpen
    }
    el[`${ctx}`] = {
      id,
      focusHandler,
      methodName: binding.expression,
      bindingFn: binding.value,
      forceOpenFn: forceOpenMethod,
      refName: vnode.data.ref
    }
  },

  update (el) {
    if (!el.getAttribute('tabindex') || el.getAttribute('tabindex') === null) {
      el.setAttribute('tabindex', -1)
    }
  },
  unbind (el) {
    for (let i = 0; i < nodeList.length; i++) {
      if (nodeList[parseInt(i)][`${ctx}`].id === el[`${ctx}`].id) {
        nodeList.splice(i, 1)
        break
      }
    }
  }
}
